module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('p', [_vm._v("Welcome to your Vue.js app!")]), _vm._v(" "), _c('dropzone', {
    attrs: {
      "id": "vueDropzone",
      "url": "http://192.168.99.100:8080/api/uploadFile",
      "useFontAwesome": true
    },
    on: {
      "vdropzone-success": _vm.showSuccess
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "token",
      "value": "xxx"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1a954308!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vueDropzone/component.vue
// module id = 3603
// module chunks = 1